// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"88":"78621eca990edd1c","405":"5c0bf1bae0bc0581","646":"3c492402389a6384","888":"e1f7c49d942f0852"}[chunkId] + ".css";
};